import { authPasswordFlowConfig } from './auth-password-flow.config';
import { OAuthService } from 'angular-oauth2-oidc';
import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router'
import { AlertService } from './alert.service';
import { deviceService } from '../servicesHardware/deviceService';



@Injectable({
  providedIn: 'root'
})
export class OidcService {
  private loginState: boolean = false;
  lang: string = ""
  private refreshTokenDelayMs: number = 100000

  //TODO delete trick LOCAL_ID for lang using i18n TS with angular 7
  constructor(private oauthService: OAuthService,
    private router: Router,
    private alertService: AlertService,
    private deviceService: deviceService,
    @Inject(LOCALE_ID) locale: any) {
    this.lang = locale
    this.oauthService.configure(authPasswordFlowConfig);
    this.oauthService.loadDiscoveryDocument();
    this.cronJob();
  }

  ngOnInit() { }


  get access_token(): string {
    return this.oauthService.getAccessToken();
  }

  get access_token_expiration(): number {
    return this.oauthService.getAccessTokenExpiration();
  }

  get givenName() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['given_name'];
  }

  get familyName() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['family_name'];
  }

  get lastConnectState() {
    return this.loginState;
  }

  get refreshTokenExist() {
    if (this.oauthService.getRefreshToken() != null && this.oauthService.getRefreshToken().length > 0)
      return true
    else
      return false
  }

  public async loginWithPassword(userName: string, password: string): Promise<boolean> {
    this.loginState = false;
    try {
      const resp = await this.oauthService.fetchTokenUsingPasswordFlow(userName, password);
      let userSession =
      {
        "currentUser": this.oauthService.getAccessToken(),
        "tokenTimeLimit": this.oauthService.getAccessTokenExpiration(),
        "accessTokenStoredAt": Date.now()
      }
      this.deviceService.encrypteDataLocalStorage('userSession', JSON.stringify(userSession))
      this.loginState = true;
      return true;

    } catch (err: any) {

      if (err.subType != null && err.subType == 0) {
        if (this.lang == "fr")
          this.alertService.error('Erreur : Communication avec le serveur d\'authentification impossible');
        else
          this.alertService.error('Error: Can not communicate with authentication server');
      }
      else {
        if (this.lang == "fr")
          this.alertService.error('Erreur : nom d\'utilisateur ou mot de passe incorrect');
        else
          this.alertService.error('Error: Invalid username or password');
      }
      this.loginState = false;
      return false;
    }
  }

  public logout() {
    this.clearLocalStorage();
    this.oauthService.logOut(true);
    this.router.navigate(['/login']);
  }

  public clearLocalStorage() {
    if (this.deviceService.decryptDataLocalStorage("currentSubscriberID") != null)
      this.deviceService.clearItemLocalStorage("currentSubscriberID");

    if (this.deviceService.decryptDataLocalStorage("userId") != null)
      this.deviceService.clearItemLocalStorage("userId");

    this.deviceService.clearItemLocalStorage('userSession');
  }

  public isConnected(): boolean {
    let session = this.deviceService.decryptDataLocalStorage('userSession')
    if (session != null && session.currentUser != null && (session.tokenTimeLimit > Date.now() - 20000)) {
      return true;
    }
    return false;
  }

  async delay(delayInMs: number): Promise<any> {
    return new Promise(resolve =>
      setTimeout(() => resolve(true), delayInMs)).
      then(() => {
        return true
      });
  }

  private async cronJob() {
    while (true) {
      if (this.oauthService.getRefreshToken() != null && this.oauthService.getRefreshToken() != "") {
        console.log("refreshToeken")
        let currentDate = new Date().valueOf()
        let expiredAt = localStorage.getItem("expires_at")
        if (expiredAt == null) expiredAt = "0"
        if ((currentDate + this.refreshTokenDelayMs) >= +expiredAt) {
          this.oauthService.refreshToken()
            .then((resp: any) => {
              if (resp != null && resp.access_token != null)
                this.updateTokenInfos()
            })
        }
      }
      await this.delay(this.refreshTokenDelayMs);
    }
  }

  private updateTokenInfos() {
    if (this.oauthService.getAccessToken() != null && this.oauthService.getAccessToken() != "") {
      let userSession =
      {
        "currentUser": this.oauthService.getAccessToken(),
        "tokenTimeLimit": this.oauthService.getAccessTokenExpiration(),
        "accessTokenStoredAt": Date.now()
      }

      let guid = localStorage.getItem("uuid")
      let jsonStringify = JSON.stringify(userSession)

      this.deviceService.encrypteDataLocalStorage('userSession', JSON.stringify(userSession))
    }
  }
}
